export default "__VITE_ASSET__643ab0c8__"